export default "__VITE_ASSET__CIEdYTCf__"